export const initialValues = {
  title: "",
  page: "",
  description: "",
  link: "",
  display_order: "",
  advertisement_images: "",
  is_active: 0,
};
